import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Container, Button, Form, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import {
    getAPettyRequestAsync,
    setPettyRequestId,
    reviewPettyRequestAsync,
    getAllPettyRequestsAsync,
} from '../../../../slices/requests/requestsSlice';
import { RootState } from "../../../../store/store";
import { toast } from "react-toastify";

interface ConfirmReviewUtilityRequestValues {
    company_id: string;
    projectId: string;
    id: string;
    action: string;
    status: string;
}

interface ConfirmReviewUtilityRequestProps {
    closeModal: () => void;
    show: boolean;
    pettyRequestId: string;
    projectId: string;
}

const ConfirmReviewUtilityRequest: React.FC<ConfirmReviewUtilityRequestProps> = ({ closeModal, show, pettyRequestId, projectId }) => {
    const dispatch = useAppDispatch();
    const companyId = useAppSelector(
        (state: RootState) => state.auth.user?.company_id || "",
    );
    const pettyRequestData = useAppSelector((state: any) => state.requests.pettyRequestData) || {};
    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageNumber, setPage] = useState(1);

    useEffect(() => {
        if (pettyRequestId) {
            dispatch(setPettyRequestId(pettyRequestId));
            console.log("Fetching petty cash request with ID:", pettyRequestId);
            dispatch(getAPettyRequestAsync({ companyId, id: pettyRequestId, projectId })).then(() =>
                setLoading(false),
            );
        } else {
            console.log("pettyRequestId is not set");
        }
    }, [dispatch, companyId, pettyRequestId, projectId]);

    if (loading) {
        return null;
    }
    console.log("pettyRequestData", pettyRequestData);
    return (
        <Container>
            <Modal className="confirm-modal" size="lg" show={show} onHide={closeModal} style={{ maxHeight: "100vh", overflowY: "auto", maxWidth: "90vh" }}>
                <div className="px-4">
                    <Formik
                        initialValues={{
                            company_id: companyId || "",
                            projectId: projectId || '',
                            id: pettyRequestData?.petty_cash_requests?.id || '',
                            action: 'review/reject',
                            status: 'reviewed',
                        }}
                        onSubmit={(values: ConfirmReviewUtilityRequestValues, { setSubmitting }) => {
                            console.log(values);
                            const addSpacesToMessage = (message: any) => {
                                return message.replace(/([a-z])([A-Z])/g, '$1 $2');
                            };
                            dispatch(
                                reviewPettyRequestAsync({
                                    ...values,
                                }),
                            ).unwrap()
                                .then((response: any) => {
                                    toast.success("Petty cash request reviewed successfully");
                                    dispatch(getAllPettyRequestsAsync({ companyId, projectId, page: pageNumber }));
                                    closeModal();
                                })
                                .catch((error: any) => {
                                    const errorMessage = error.message ? addSpacesToMessage(error.message) : "An unexpected error occurred";
                                    toast.error(errorMessage);
                                })
                                .finally(() => {
                                    setSubmitting(false);
                                });
                        }}
                    >
                        {({ handleSubmit, isSubmitting }) => (
                            <Form onSubmit={handleSubmit}>
                                <Modal.Header closeButton className='text-start'>
                                    <h4 className="confirm-header">Review petty cash request</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="confirm-body">Are you sure want to review this request?</p>
                                </Modal.Body>
                                <Modal.Footer className='mt-2'>
                                    <Row >
                                        <Col md={6}>
                                            <div className=' mt-1'>
                                                <Button onClick={closeModal} className='cancel-btn'>
                                                    <span className="text-center">No </span>                                        </Button>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className=' mt-1'>
                                                <Button type='submit' className=' border-0 create-btn bg-color-1'>
                                                    {isSubmitting ? (
                                                        <Spinner animation="border" size="sm" />
                                                    ) : (
                                                        <span className="text-center"> Yes</span>
                                                    )}                              </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
        </Container>
    )
}

export default ConfirmReviewUtilityRequest;